import { handleGetFeedback } from 'Actions/SuperAdmin/JobsAction';
import React from 'react'
import ReactPaginate from 'react-paginate';
import { useCommonState, useCustomNavigate, useDispatch } from 'ReusableFunctions/CustomHooks'
import { encryptData } from 'Security/Crypto/Crypto';
import { update_feedback_change } from 'Slices/SuperAdmin/Jobs';
import Rating from 'views/common/Rating';
import InputGroup from '../../components/Input/InputGroup';
import { IoIosSearch } from 'react-icons/io';
import { MdClear } from "react-icons/md";


const SuperAdminFeedback = () => {
    const { saJobsState } = useCommonState();
    const dispatch = useDispatch();
    const navigate = useCustomNavigate();
    const category = ["Professional", "Employer"];

    React.useEffect(() => {
        dispatch(update_feedback_change({ type: "reset" }))
    }, [])

    React.useEffect(() => {
        let params
        if (saJobsState?.search_clicked) params = { search_text: saJobsState?.feedback_search_input, user_role: saJobsState?.feedback_category, page_number: saJobsState?.current_page + 1 }
        else params = { user_role: saJobsState?.feedback_category, page_number: saJobsState?.current_page + 1 }

        dispatch(handleGetFeedback({
            endpoint: saJobsState?.search_clicked ? "/feedback_search" : "/get_users_feedback",
            data: params
        }))
    }, [saJobsState?.feedback_category, saJobsState?.current_page, saJobsState?.search_clicked])

    return (
        <div className="py-5 h-100">
            <div className="col-12 col-md-9 col-lg-5 row pb-3 ms-auto">
                <div className="col-6">
                    <select
                        className="form-select"
                        style={{ padding: '0.55rem 2.3rem' }}
                        value={saJobsState?.feedback_category}
                        onChange={(e) => dispatch(update_feedback_change({ type: "feedback_category", data: e.target.value }))}>
                        {category.map((item, index) => (
                            <option key={index} value={item?.toLowerCase()}>{item}</option>
                        ))}
                    </select>
                </div>
                <div className="col-6">
                    <div className="d-flex position-relative">
                        <InputGroup
                            className="home-search-icon fs-5"
                            reIcons={<IoIosSearch />}
                        />

                        <input type="text"
                            className="form-control"
                            style={{ padding: '0.55rem 4.5rem 0.55rem 2.3rem' }}
                            placeholder="Search"
                            value={saJobsState?.feedback_search_input}
                            onChange={(e) => dispatch(update_feedback_change({ type: "feedback_search_input", data: e.target.value }))}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") dispatch(update_feedback_change({ type: 'search_clicked' }))
                            }
                            }
                        />

                        {
                            saJobsState?.feedback_search_input ?
                                <div className='searchButtonClick-superAdmin' title='Search' onClick={() => dispatch(update_feedback_change({ type: 'search_clicked' }))}>
                                    <IoIosSearch />
                                </div>
                                :
                                null
                        }

                        <div className='clearButtonClick-superAdmin' title='Clear' onClick={() => dispatch(update_feedback_change({ type: 'search_clicked_false' }))}>
                            <MdClear />
                        </div>
                    </div>

                </div>
            </div>
            <div className="card px-3 rounded-3" style={{ height: '95%' }}>
                {
                    saJobsState?.feedback_glow ?
                        <div className="d-flex flex-wrap justify-content-center align-items-center" style={{ height: '100%' }}>
                            <div className="col-4 text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className='w-100 mt-2'>Getting feedback..</p>
                            </div>
                        </div>
                        :
                        saJobsState?.feedback_data?.feedback?.length ?
                            <div className="card-body px-0">
                                <div className="row">
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th className='col'>S.No</th>
                                                    <th className='col'>{saJobsState?.feedback_category === "Professional" ? "Professional" : "Employer"} Id</th>
                                                    <th className='col'>Name</th>
                                                    <th className='col'>Email</th>
                                                    <th className='col'>Rating</th>
                                                    <th className='col'>Summary</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    saJobsState?.feedback_data?.feedback?.map((feedback, feedback_index) => (
                                                        <tr>
                                                            <td className='col'>{(saJobsState?.current_page * 10) + feedback_index + 1}</td>
                                                            <td className='col'>{feedback?.user_id}</td>
                                                            <td className='col'>{feedback?.full_name}</td>
                                                            <td className='col'>{feedback?.email_id}</td>
                                                            <td className='col'>
                                                                <Rating rated={feedback?.rating} className="pe-none" />
                                                            </td>
                                                            <td className='col'>
                                                                <button
                                                                    type="button"
                                                                    className='btn bg-transparent text-primary text-decoration-underline'
                                                                    onClick={() => navigate(`feedback_details?e_id=${encryptData(feedback?.email_id)}&&role=${saJobsState?.feedback_category}`)}
                                                                >
                                                                    Chat summary
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="d-flex flex-wrap justify-content-center align-items-center" style={{ height: '100%' }}>
                                <p className='text-center'>No Data Found</p>
                            </div>
                }

                {
                    saJobsState?.feedback_data?.total_count > 10 ?
                        <div className="col-4 ms-auto pb-5">
                            <ReactPaginate
                                previousLabel={"Previous"}
                                nextLabel={"Next"}
                                breakLabel={'...'}
                                pageCount={Math.ceil(saJobsState?.feedback_data?.total_count / 10)}
                                forcePage={saJobsState?.current_page}
                                pageRangeDisplayed={2}
                                marginPagesDisplayed={2}
                                onPageChange={(page) => dispatch(update_feedback_change({ type: "current_page", current_page: page?.selected }))}
                                containerClassName={"pagination col-12 justify-content-center mb-0"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link "}
                                previousClassName={"page-item"}
                                previousLinkClassName={"page-link"}
                                nextClassName={"page-item"}
                                nextLinkClassName={"page-link"}
                                breakClassName={"page-item"}
                                breakLinkClassName={"page-link"}
                                activeClassName={"active"}
                            />
                        </div>
                        :
                        null
                }
            </div>
        </div >
    )
}

export default SuperAdminFeedback